import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  isAllowedToAccessNormalPortal(): boolean {
    return environment.allowNormalPortalAccess;
  }

  isAllowedToAccessProviderPortal(): boolean {
    return environment.allowProviderPortalAccess;
  }

  isAllowedToAccessBrokerPortal(): boolean {
    return environment.allowBrokerPortalAccess;
  }

  isAllowedToSubmitClaimForProviderPortal(): boolean {
    return environment.allowSubmitClaimForProviderPortal;
  }

  isAllowedToSubmitAuthForProviderPortal(): boolean {
    return environment.allowSubmitAuthForProviderPortal;
  }

  isAllowedToSubmitClaimForNormalPortal(): boolean {
    return environment.allowSubmitClaimForNormalPortal;
  }

  isAllowedToSubmitAuthForNormalPortal(): boolean {
    return environment.allowSubmitAuthForNormalPortal;
  }

  isCasesFeatureEnabled(): boolean {
    return environment.claimManagementFeatures.cases;
  }

  isPaymentsFeatureEnabled(): boolean {
    return environment.claimManagementFeatures.payments;
  }

  isAllowedToViewGovernmentData(): boolean {
    return environment.allowGovernmentData;
  }
  isAllowHealthCloudScore(): boolean {
    return environment.allowHealthCloudScore;
  }

  isPrimarySubClassNone(): boolean {
    return this.getPrimarySubClass() === 'None';
  }

  isPrimarySubClassPharmacy(): boolean {
    return this.getPrimarySubClass() === 'Pharmacy';
  }

  requireCaseToCaptureTransaction(): boolean {
    return environment.requireCaseToCaptureTransaction;
  }

  getPrimarySubClass(): string {
    return environment.primarySubClass;
  }

  getCurrentEnvironmentName(): string {
    return environment.environmentName;
  }

  getPharmacyDirectNumber(): string {
    return environment.defaultPracticeNumber;
  }

  isDefaultDispensingProvider(): boolean {
    return this.isPrimarySubClassPharmacy() && environment.defaultPracticeNumber !== null && environment.defaultPracticeNumber !== '';
  }

  getEncounterOverrideIndicatorNames(): { [key: string]: string } {
    return environment.encounterOverrideIndicators;
  }

  getActivityOverrideIndicatorNames(): { [key: string]: string } {
    return environment.activityOverrideIndicators;
  }

  getJiraWidgetDataKey(): string {
    return environment.jiraWidget?.dataKey;
  }
  getTheme(): string {
    return environment.theme;
  }

  getFavicon(): string {
    return environment.favicon;
  }

  showJiraWidget(): boolean {
    return environment.jiraWidget?.showWidget;
  }
  getVatPercentage(): number {
    return environment.vatPercentage;
  }
  isJiraApiEnabled(): boolean {
    return environment.jiraApi.enabled;
  }
  getJiraApiBaseUr(): string {
    return environment.jiraApi.baseUrl;
  }
  getJiraApiServiceDeskId(): string {
    return environment.jiraApi.serviceDeskId;
  }
  getJiraApiKeyPrefix(): string {
    return environment.jiraApi.keyPrefix;
  }

  getAcceptedApplicationLookBackDays(): number {
    return environment.acceptedApplicationLookBackDays;
  }

  // Added method to get the application capture schema configuration
  getSchemeConfig(): { schemeCode: string; schemeName: string, individualCode: string } {
    return {
      schemeCode: environment.applicationCapture?.scheme?.schemeCode || '',
      schemeName: environment.applicationCapture?.scheme?.schemeName || '',
      individualCode: environment.applicationCapture?.individualCode || ''
    };
  }

  getWelcomePackSendEnabled(): boolean {
    return environment.applicationCapture?.allowCommunicationPackSend || false;
  }

  getExternalClientUrl(): string {
    return environment.externalClientUrl;
  }

}
